export default __webpack_public_path__ + "static/media/xnft_05-min 2.a33e1ab4.svg";